// Broken link, used on the "no team" chip for someone with no approver of record.
// Decorative — the control it sits in carries the accessible name, so the glyph
// is aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function UnlinkIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <path d="M9.2 14.8 7 17a4.2 4.2 0 0 1-5.9-5.9l2.2-2.2" />
      <path d="M14.8 9.2 17 7a4.2 4.2 0 0 1 5.9 5.9l-2.2 2.2" />
      <line x1="3" y1="3" x2="21" y2="21" />
    </svg>
  );
}
